import { useAdmin } from '../../hooks/use-admin-context';
import { Button } from '../form/button';
import { Typography } from '../typography/typography';

export const ImportExportToolbar = ({
  children,
  setIsImportOpen,
  setIsExportOpen,
  Import,
  Export,
}: {
  children: React.ReactNode;
  setIsImportOpen: React.Dispatch<React.SetStateAction<boolean>>;
  setIsExportOpen: React.Dispatch<React.SetStateAction<boolean>>;
  Import: () => JSX.Element;
  Export: () => JSX.Element;
}) => {
  const { isSuperAdmin } = useAdmin();

  const ButtonShared = ({ onClick, label }: { onClick: () => void; label: string }) => (
    <Button data-cy={`${label.toLowerCase()}-button`} className="button button-secondary" onClick={onClick}>
      <div className="pl-2 pr-2">
        <Typography type="text-sm" className="p-2" weight="semi-bold">
          {label}
        </Typography>
      </div>
    </Button>
  );

  const ImportButton = () => <ButtonShared onClick={() => setIsImportOpen(true)} label="Import" />;
  const ExportButton = () => <ButtonShared onClick={() => setIsExportOpen(true)} label="Export" />;

  return (
    <>
      <Import />
      <Export />

      <div className="flex flex-row gap-2">
        {isSuperAdmin && <ImportButton />}
        <ExportButton />
        {children}
      </div>
    </>
  );
};
